<template>
  <v-navbar-menu-item icon="search" href="#" @click.prevent="openSearch()" v-on="$listeners">
    {{title}}
    <slot></slot>
  </v-navbar-menu-item>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    openSearch() {
      this.$root.$emit("open-fullscreen-search");
    }
  }
};
</script>
